import React from "react";

/**
 * LuksLogo — official LUKS Solutions brand logo (image asset).
 * Variants:
 *   - "dark"  : for light backgrounds (default)
 *   - "light" : for dark backgrounds (footer) — inverts image to white
 *
 * The image includes the star mark + "LUKS SOLUTIONS" wordmark baked in,
 * so no separate text wordmark is rendered.
 */
export const LuksLogo = ({ variant = "dark", className = "" }) => {
  const isLight = variant === "light";
  return (
    <img
      src="/luks-logo.png"
      alt="Luks Solutions"
      className={`h-14 sm:h-16 w-auto select-none ${className}`}
      style={
        isLight
          ? { filter: "brightness(0) invert(1)" }
          : undefined
      }
      draggable={false}
    />
  );
};

/* Kept for API compatibility elsewhere (e.g., product page compact spots) */
export const LuksMark = ({ className = "h-9 w-9" }) => (
  <img
    src="/luks-logo.png"
    alt="Luks Solutions"
    className={`${className} object-contain select-none`}
    draggable={false}
  />
);

export default LuksLogo;
